<template>
    <div>
        <!--<div style="margin-bottom: 10px;">-->
            <!--<span style="font-size: 14px;font-weight: 600;padding-right: 20px;cursor: pointer;" @click="handleClick"><i class="el-icon-back"></i>返回</span>任务ID： {{id}}-->
        <!--</div>-->
        <div class="create_page_header" :style="{width: fixWidth}">
            <el-button type="text" icon="el-icon-back" :style="{fontSize: '14px'}" @click="handleClick" v-matomo="{behaviorCategory: 'vivo(列表)',  name: '任务详情(返回)' }">返回</el-button>
            <span class="text pl10 pr10 font14px">|</span>
            <span class="text pr10 font14px text-bold">批量创建详情</span>
           <span class="ml20 text-color-gray text-bold"> 任务ID： {{id}}</span>
        </div>

        <div class="create_page_body">
            <el-form :inline="true" :model="formInline" ref="formInline" class="demo-form-inline" size="mini">
                <el-form-item label="目标账户" prop="account_id">
                    <SelectAll v-model="formInline.account_id" :placeholder="'支持账户名称关键字或用户名搜索'" :multiple=false style="width:230px;"
                               :remote=true
                               :remote-query="(query)=>fetchApi({task_id:id,search_type:'account',query: query})"
                    />
<!--                    <el-input v-model="formInline.account_id" placeholder="支持账户名称关键字或用户名搜索"  style="width:230px;" clearable/>-->
                    <!-- <el-select v-model="formInline.account_id" placeholder="支持账户名称关键字或用户名搜索" style="width:230px;" clearable
                        filterable
                    >
                    <el-option
                        v-for="item in account"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        <span style="float: left">{{ item.name }}</span>
                    </el-option>
                    </el-select> -->
                </el-form-item>

                <el-form-item label="产品" prop="package_name">
                    <SelectAll v-model="formInline.package_name" :placeholder="'产品名称、ID、包名关键字搜索'" style="width:230px;"
                               :remote=true
                               :remote-query="(query)=>fetchApi({task_id:id,search_type:'app',query: query})"
                    />
                    <!--<el-input v-model="formInline.package_name" placeholder="支持产品名称、包名或ID搜索"  style="width:230px;" clearable/>-->
<!--                    <el-select-->
<!--                        v-model="formInline.package_name"-->
<!--                        placeholder="产品名称、ID、包名关键字搜索"-->
<!--                        style="width: 260px"-->
<!--                        class="tagswidth"-->
<!--                        multiple-->
<!--                        collapse-tags-->
<!--                        clearable-->
<!--                        filterable-->
<!--                        remote-->
<!--                        :remote-method="(query)=>remoteMethod(query, 'app')"-->
<!--                    >-->
<!--                        <el-option-->
<!--                            v-for="item in app"-->
<!--                            :key="item.id+item.package_name"-->
<!--                            :label="item.name+'('+item.id+')'+'('+item.package_name+')'"-->
<!--                            :value="item.package_name">-->
<!--                            <span style="float: left">{{ item.name }}（{{item.id}}）（{{item.package_name}}）</span>-->
<!--                        </el-option>-->
<!--                    </el-select>-->





                </el-form-item>
                <el-form-item label="计划" prop="plan_id">
                    <el-input v-model="formInline.plan_id" placeholder="支持计划名称关键字或ID搜索"  style="width:230px;" clearable/>
                    <!-- <el-select v-model="formInline.plan_id" placeholder="支持计划名称关键字或ID搜索" style="width:230px;" clearable
                        filterable
                    >
                    <el-option
                        v-for="item in plan"
                        :key="item.id"
                        :label="item.name+item.id"
                        :value="item.id">
                        <span style="float: left">{{ item.name }}({{item.id}})</span>
                    </el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="广告组" prop="adgroup_id">
                    <el-input v-model="formInline.adgroup_id" placeholder="支持广告组名称关键字或ID搜索"  style="width:230px;" clearable/>
                    <!-- <el-select v-model="formInline.adgroup_id" placeholder="支持广告组名称关键字或ID搜索" style="width:230px;" clearable
                        filterable
                    >
                    <el-option
                        v-for="item in group"
                        :key="item.id"
                        :label="item.name+item.id"
                        :value="item.id">
                        <span style="float: left">{{ item.name }}({{item.id}})</span>
                    </el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="广告" prop="ad_id">
                    <el-input v-model="formInline.ad_id" placeholder="支持广告名称关键字或者ID搜索"  style="width:230px;" clearable/>
                    <!-- <el-select v-model="formInline.ad_id" placeholder="支持广告名称关键字或者ID搜索" style="width:220px;" clearable
                        filterable
                    >
                    <el-option
                        v-for="item in ad"
                        :key="item.id"
                        :label="item.name+item.id"
                        :value="item.id">
                        <span style="float: left">{{ item.name }}({{item.id}})</span>
                    </el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="formInline.status" placeholder="全部" multiple style="width:120px;" clearable>
                        <el-option label="创建中" value="1"></el-option>
                        <el-option label="创建成功" value="2"></el-option>
                        <el-option label="创建计划失败" value="3"></el-option>
                        <el-option label="创建广告组失败" value="4"></el-option>
                        <el-option label="创建广告失败" value="5"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit" v-matomo="{behaviorCategory: 'vivo(列表)',  name: '任务详情(查询)' }">筛选</el-button>
                    <el-button @click="resetForm('formInline')" v-matomo="{behaviorCategory: 'vivo(列表)',  name: '任务详情(重置筛选)' }">重置筛选</el-button>
                </el-form-item>
            </el-form>

            <!--<div>-->
            <!--数量总计（<span class="text-color-success">成功</span>/总数）：计划（<span class="text-color-success">{{gather.success_plan_num}}</span>/{{gather.plan_num}}）；广告组（<span class="text-color-success">{{gather.success_adgroup_num}}</span>/{{gather.adgroup_num}}）；广告（<span class="text-color-success">{{gather.success_ad_num}}</span>/{{gather.ad_num}}）；创意（<span class="text-color-success">{{gather.success_idea_num}}</span>/{{gather.idea_num}}）-->
            <!--</div>-->

            <jt-table :data="tableData"
                        :affixConfig="{offset: { top: 104, bottom: 0}}"
                      style="width: 100%;margin-top: 20px;"
                      stripe
                      :header-cell-style="{background:'#e8eaec',color:'#333'}"
                      size="mini"
                      row-key="id"
                      ref="toggleRowEx"
                      class="create_vivo_list"
                      v-loading="loading"
                      tooltip-effect="dark">
                <el-table-column type="expand" width="1">
                    <template slot-scope="scope">
                        <div class="full-w min-height-150" v-if="scope.row.expend" v-loading="scope.row.expendLoading">
                            <ExpandItem :params="scope.row.params"  :isAimedia="isAimedia" />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="120">
                    <template slot-scope="scope">
                        <template v-if="scope.$index==0">
                            <span>汇总(成功/失败)</span>
                        </template>
                        <template v-else>
                            <p v-if="scope.row.status == 1" class="text-color-info">{{ scope.row.status_text}}<i class="el-icon-loading"></i></p>
                            <p v-else-if="scope.row.status == 2" class="text-color-success">{{ scope.row.status_text}}</p>
                            <p v-else class="text-color-error">{{ scope.row.status_text}}<el-tooltip class="item" effect="dark" :content="scope.row.err_msg" placement="top-start"><i class="el-icon-warning-outline"></i></el-tooltip></p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="目标账户" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.$index==0">{{scope.row.success_account_num}}/{{scope.row.err_account_num}}</div>
                        <div v-else>
                            <p class="ellipsis">{{scope.row.account_name}}</p>
                            <br>
                            <p class="ellipsis">用户名:{{scope.row.user_name}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="投放产品" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.$index==0">{{scope.row.success_app_num}}/{{scope.row.err_app_num}}</div>
                        <div v-else>
                            <p class="ellipsis">{{scope.row.app_name}}({{scope.row.app_id}})</p>
                            <br>
                            <p class="ellipsis">{{scope.row.app_package_name}}</p>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="计划名称" min-width="200"  show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.$index==0">{{scope.row.success_plan_num}}/{{scope.row.err_plan_num}}</div>
                        <div v-else>
                            <p class="ellipsis">{{ scope.row.plan_name }}</p>
                            <br/>
                            <p class="ellipsis" v-if="scope.row.plan_id">ID:{{scope.row.plan_id}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="广告组名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.$index==0">{{scope.row.success_adgroup_num}}/{{scope.row.err_adgroup_num}}</div>
                        <div v-else>
                            <p class="ellipsis">{{ scope.row.adgroup_name }}</p>
                            <br/>
                            <p class="ellipsis" v-if="scope.row.adgroup_id">ID:{{scope.row.adgroup_id}}</p>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="广告名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.$index==0">{{scope.row.success_ad_num}}/{{scope.row.err_ad_num}}</div>
                        <div v-else>
                            <p class="ellipsis">{{ scope.row.ad_name }}</p>
                            <br/>
                            <p class="ellipsis" v-if="scope.row.ad_id">ID:{{scope.row.ad_id}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="90" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.$index!=0"
                            size="mini"
                            type="text"
                            @click="toggleRow(scope.$index, scope.row)"
                            v-matomo="{behaviorCategory: 'vivo(列表)',  name: '任务详情(创意详情)' }"
                        >创意详情<i class="el-icon-arrow-down" v-if="!scope.row.expend"></i><i class="el-icon-arrow-up" v-else></i></el-button>
                    </template>
                </el-table-column>
            </jt-table>

            <div style="text-align: right;padding-top: 20px;">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 30, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>


    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ExpandItem from '../components/expandItem';
import SelectAll from '@/components/SelectAll'
import {GET_DETAIL_SEARCH_LIST, GET_DETAIL_TOTAL, GET_DETAIL, GET_DETAIL_IDEA_LIST, getSmartProductDetailIdeaListApi} from "@/api/create-vivo.js"
import { JtTable } from '@/components/Ele'
export default {
    name: "infopage",
    components: {
        SelectAll,
        ExpandItem,
        JtTable
    },
    props:{
        id: '',
        isAimedia:{
            type: Boolean,
        }
    },
    data() {
        return {
            fixWidth:'1000px',
            fetchApi:GET_DETAIL_SEARCH_LIST,
            formInline: {
                account_id: '',      //任务ID
                plan_id: '',      //计划
                app_id: '',      //投放产品
                package_name: [], //产品
                adgroup_id: '',   //广告组ID
                ad_id: '',        //广告ID
                status: ''        //状态
            },
            // account: [],            //select搜索
            // plan: [],            //select搜索
            // group: [],            //select搜索
            // ad: [],            //select搜索
            app: [],            //select搜索
            gather: {               //数据汇总
                plan_num: "",
                success_plan_num: "",
                adgroup_num: "",
                success_adgroup_num: "",
                ad_num: "",
                success_ad_num: "",
                idea_num: "",
                success_idea_num: ""
            },
            loading:true,  // 表格loading
            currentPage: 1,
            pageSize: 10,
            total: 10,
            monitor: null, //定时器
            equal: 1, //缓存请求赋值
            status_err:[],
            tableData: [],
            dialogVisible: false,
        }
    },
    computed:{
        ...mapGetters(['sidebar']),
    },
    mounted() {
        // ['account', 'plan', 'group', 'ad'].forEach(item=>{
        //     GET_DETAIL_SEARCH_LIST({search_type:item,task_id:this.id}).then(res=>{
        //         let result = res.data
        //         this[item] = result
        //     })
        // })
        this.getFixWidth();
        window.addEventListener("resize", this.getFixWidth);
        this.init()
    },
    watch:{
        sidebar: {
            handler(){
                setTimeout(this.getFixWidth, 300)
            },
            deep:true,
        }
    },
    methods: {
        getFixWidth(){
            let $createBody = document.querySelector('.create_page_body');
            this.fixWidth = `${$createBody.clientWidth}px`;
        },
        toConfigPage() {
            this.$emit("changePage", "config")
        },
        // remoteMethod(type) {
        //     GET_DETAIL_SEARCH_LIST({search_type:type}).then(res=>{
        //         let result = res.data
        //         let opt = `options_${type}`
        //         this[opt] = result
        //     })
        // },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.tableData = [];
            this.handleKill()
            this.init()
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            this.tableData = [];
            this.handleKill()
            this.init()
        },
        onSubmit() {
            this.handleKill()
            this.currentPage = 1
            this.init()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$nextTick(()=>{
                this.currentPage = 1
                this.init()
            })
        },
        toggleRow(index, row) {
            this.$refs.toggleRowEx.toggleRowExpansion(row, !row.expend);
            row.params = [];
            row.expendLoading = true
            row.expend = !row.expend
            if(this.isAimedia) {
                getSmartProductDetailIdeaListApi({detail_id:row.detail_id}).then(res=>{
                    row.params = res.data
                    row.expendLoading = false
                }).catch((err)=>{
                    this.$message.error(err.info)
                });
            }else {
                 // isAimedia
                GET_DETAIL_IDEA_LIST({detail_id:row.detail_id}).then(res=>{
                    row.params = res.data
                    row.expendLoading = false
                }).catch((err)=>{
                    this.$message.error(err.info)
                });
            }
           
        },
        handleClick() {
            this.handleKill()
            this.delayedClear()
            this.$emit('goback')
        },
        init() {
            this.handleKill()
            // let obj = {...this.formInline, pn: this.currentPage, rn: this.pageSize, task_id:this.id}
            this.loading = true
            this.polling()
        },
        polling(isUpdateStatus) {
            let params = {...this.formInline, pn: this.currentPage, rn: this.pageSize, task_id:this.id}
            GET_DETAIL_TOTAL(params).then(totalList=>{
                this.gather = totalList.data
                GET_DETAIL(params).then(res=>{
                    let result = res.data
                    this.loading = false

                    let createarr = []
                    result.list.forEach(element => {
                        if(element.status == 1) {
                            createarr.push(element.id)
                        }
                    });


                    if(isUpdateStatus=='updateStatus'){
                        /*仅更新状态*/
                        result.list.forEach(item => {
                            let actionItem = this.tableData.find(inner=>inner.detail_id==item.detail_id);
                            if(actionItem){
                                actionItem.status = item.status;
                                actionItem.status_text = item.status_text;
                                actionItem.err_msg = item.err_msg;
                            }

                        });
                    }else{
                        this.tableData = [this.gather].concat(result.list.map(((item, index)=>{
                            item.id = index
                            item.expendLoading = false;
                            item.params = [];
                            this.$refs.toggleRowEx.toggleRowExpansion(item, false);
                            item.expend  =false;
                            return {...item}
                        })));
                        this.currentPage = result.pageNum
                        this.pageSize = result.pageSize
                        this.total = result.totalCnt;
                    }

                    if(createarr.length != 0) {
                        // let obj = {...this.formInline, pn: this.currentPage, rn: this.pageSize, task_id:this.id}
                        // this.monitor = setTimeout(()=>{this.polling('updateStatus')}, 5000)
                    }else{
                        this.handleKill()
                    }

                })
            })

        },
        handleKill() {
            for(let i=1; i< 10; i++) {
                clearTimeout(this.monitor)
                this.monitor = null
                this.equal = 1
            }

        },
        delayedClear() {
            setTimeout(()=>{
                for(let i=1; i<10; i++) {
                    clearTimeout(this.monitor)
                    this.monitor = null
                    this.equal = 1
                }
            }, 5000)
        },
        remoteMethod(query, type) {
            if(!query) return;
            GET_DETAIL_SEARCH_LIST({
                task_id:this.id,
                // plan_id:this.formInline.plat_id,
                search_type:type,
                query: query
            }).then(res=>{
                let result = res.data
                this[type] = result
            })
        },
    },
    beforeDestroy() {
        this.handleKill()
        this.delayedClear()
        window.removeEventListener("resize", this.getFixWidth);
    },
    destroyed() {
        this.handleKill()
        this.delayedClear()
    }
}
</script>

<style>
.create_vivo_list .el-table__expand-icon .el-icon-arrow-right{
    opacity: 0;
}
</style>
<style lang="scss" scoped>
.ellipsis{
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}
.create_vivo_list tbody .cell div{
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}
.demo-form-inline{
    padding: 20px 20px 0;
    background: #f8f8f9;
    margin-bottom: 20px;
}
.create_page_header{
    border-top: solid 10px #fff;
    background-color: #fff;
    padding: 4px 8px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    position: fixed;
    top: 52px;
    z-index: 30;
    box-shadow: 0 1px 2px #d9d9d9;
    .text {
        display:inline-block;
        line-height: 32px;
    }
}
.create_page_body{
    margin-top: 42px;
    background-color: #fff;
    min-height:  calc(100vh - 135px);
    padding-bottom: 50px;
}
.min-height-150{
    min-height: 150px;
}
</style>
